module.exports = __webpack_public_path__ + "static/media/image-primary2.e56b6f8f.svg";